import { IconsTypesProps } from '../../types';

export const RegularPumpWithRotor = ({
  width = 64,
  height = 47,
  fill = '#05B6B2',
}: IconsTypesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.51992 36.0371L4.26791 36.0371C4.03783 36.0371 3.851 35.8492 3.851 35.6178C3.851 35.3864 3.66417 35.1985 3.43409 35.1985L2.42176 35.1985C1.63594 35.1985 0.999994 35.8381 1 36.6284L1.00003 40.6429C1.00004 41.4362 1.64053 42.0803 2.42925 42.0803H3.50179C3.6948 42.0803 3.851 41.9232 3.851 41.7291C3.851 41.535 4.0072 41.3779 4.20021 41.3779H18.3794C18.7663 41.3779 19.0795 41.0629 19.0795 40.6738C19.0795 40.2846 19.3926 39.9697 19.7796 39.9697L27.5085 39.9696C28.3073 39.9696 28.9537 39.3194 28.9537 38.5161L28.9537 35.5282C28.9537 34.7248 29.6002 34.0747 30.399 34.0747H33.8287C34.6304 34.0747 35.2815 34.7295 35.2815 35.5359L35.2816 37.178C35.2816 37.9843 35.9326 38.6391 36.7344 38.6391L49.0837 38.6391C49.4487 38.6391 49.7451 38.9373 49.745 39.3044C49.745 39.6715 50.0414 39.9696 50.4064 39.9696L61.929 39.9696C62.7278 39.9696 63.3742 39.3194 63.3742 38.516L63.3742 22.1231C63.3742 21.3167 62.7232 20.6619 61.9214 20.6619L50.1312 20.6619C49.6488 20.6619 49.2584 21.0545 49.2584 21.5397C49.2584 22.0249 48.868 22.4175 48.3856 22.4175L36.7268 22.4175C35.928 22.4175 35.2816 23.0676 35.2816 23.871L35.2815 25.6688C35.2815 26.4722 34.6351 27.1224 33.8363 27.1224H30.4066C29.6048 27.1224 28.9538 26.4676 28.9538 25.6612V22.9652C28.9538 22.1588 28.3027 21.504 27.5009 21.504L7.71074 21.5039C6.91192 21.5039 6.26546 22.1541 6.26546 22.9574L6.26547 34.5759C6.26547 35.3823 6.91656 36.0371 7.71834 36.0371H13.5316C14.3304 36.0371 14.9769 35.387 14.9769 34.5836L14.9769 30.5872C14.9769 30.3854 14.9747 30.1802 15.0041 29.9805C15.1032 29.3095 15.5622 27.7549 17.6888 27.7549C19.7062 27.7549 20.1417 29.3092 20.2357 29.9803C20.2637 30.1802 20.2616 30.3854 20.2616 30.5872V39.0606M49.8737 23.6117V37.2349M49.5364 24.9333H39.6622M49.5364 26.6186H39.6622M49.5364 28.3039H39.6622M49.5364 29.9896H39.6622M49.5364 31.6749H39.6622M11.1801 41.4504L10.3456 43.2762M8.56911 43.1334V45.6614M15.2445 19.8194V21.5047M20.1121 19.8194V21.5047M15.2445 9.7076V17.713M20.1121 9.70739V17.7127M15.2446 3.10663V7.60087M20.112 3.10677V7.601M60.7214 43.1334V45.6614M60.3841 43.472H8.37092M64 46H4.755M23.8255 39.8805L25.4944 42.9703M49.5364 33.3602H39.6622M49.5364 35.0455H39.6622M49.5364 36.7308H39.6622M55.593 25.8586H58.3607C59.0174 25.8586 59.5497 25.3241 59.5497 24.6648C59.5497 24.0055 59.0174 23.471 58.3607 23.471H55.593C54.9363 23.471 54.404 24.0055 54.404 24.6648C54.404 25.3241 54.9363 25.8586 55.593 25.8586ZM15.122 19.8194H19.8383C20.4177 19.8194 20.8874 19.3478 20.8874 18.7661C20.8874 18.1843 20.4177 17.7127 19.8383 17.7127H15.122C14.5426 17.7127 14.0729 18.1843 14.0729 18.7661C14.0729 19.3478 14.5426 19.8194 15.122 19.8194ZM15.122 9.70758H19.8383C20.4177 9.70758 20.8874 9.23599 20.8874 8.65425C20.8874 8.0725 20.4177 7.60091 19.8383 7.60091H15.122C14.5426 7.60091 14.0729 8.0725 14.0729 8.65425C14.0729 9.23599 14.5426 9.70758 15.122 9.70758ZM15.122 3.10667H19.8383C20.4177 3.10667 20.8874 2.63508 20.8874 2.05334C20.8874 1.47159 20.4177 1 19.8383 1H15.122C14.5426 1 14.0729 1.47159 14.0729 2.05334C14.0729 2.63508 14.5426 3.10667 15.122 3.10667Z"
      stroke="#8C969B"
    />
    <path
      d="M17.3943 35.2805C20.1615 35.2805 22.4048 33.0662 22.4048 30.3346C22.4048 27.603 20.1615 25.3887 17.3943 25.3887C14.6271 25.3887 12.3838 27.603 12.3838 30.3346C12.3838 33.0662 14.6271 35.2805 17.3943 35.2805Z"
      fill={fill}
    />
    <path
      d="M17.4076 27.5198V23C17.4076 23 15.7984 23.5424 15.7461 25.5311C14.9873 25.7893 14.294 26.2155 13.7314 26.7837"
      fill={fill}
    />
    <path
      d="M17.4076 27.5198V23C17.4076 23 15.7984 23.5424 15.7461 25.5311C14.9873 25.7893 14.294 26.2155 13.7314 26.7837"
      stroke="#231F20"
      strokeWidth="0.258273"
      strokeMiterlimit="10"
    />
    <path
      d="M15.367 28.3713L12.1357 25.1816C12.1357 25.1816 11.39 26.6796 12.7636 28.126C12.4235 28.8104 12.2534 29.5723 12.2534 30.3342C12.2534 30.36 12.2534 30.3729 12.2534 30.3988"
      fill={fill}
    />
    <path
      d="M15.367 28.3713L12.1357 25.1816C12.1357 25.1816 11.39 26.6796 12.7636 28.126C12.4235 28.8104 12.2534 29.5723 12.2534 30.3342C12.2534 30.36 12.2534 30.3729 12.2534 30.3988"
      stroke="#231F20"
      strokeWidth="0.258273"
      strokeMiterlimit="10"
    />
    <path
      d="M14.5427 30.3994H9.96387C9.96387 30.3994 10.5133 32.0007 12.5542 32.0524C12.8158 32.7884 13.2606 33.4599 13.8362 34.0023"
      fill={fill}
    />
    <path
      d="M14.5427 30.3994H9.96387C9.96387 30.3994 10.5133 32.0007 12.5542 32.0524C12.8158 32.7884 13.2606 33.4599 13.8362 34.0023"
      stroke="#231F20"
      strokeWidth="0.258273"
      strokeMiterlimit="10"
    />
    <path
      d="M15.4061 32.4131L12.1748 35.6028C12.1748 35.6028 13.7316 36.3518 15.2099 34.9312C15.8902 35.2412 16.6359 35.4091 17.3946 35.4091"
      fill={fill}
    />
    <path
      d="M15.4061 32.4131L12.1748 35.6028C12.1748 35.6028 13.7316 36.3518 15.2099 34.9312C15.8902 35.2412 16.6359 35.4091 17.3946 35.4091"
      stroke="#231F20"
      strokeWidth="0.258273"
      strokeMiterlimit="10"
    />
    <path
      d="M17.46 33.2266V37.7463C17.46 37.7463 19.1214 37.1911 19.1345 35.112C19.854 34.8537 20.5081 34.4405 21.0445 33.911"
      fill={fill}
    />
    <path
      d="M17.46 33.2266V37.7463C17.46 37.7463 19.1214 37.1911 19.1345 35.112C19.854 34.8537 20.5081 34.4405 21.0445 33.911"
      stroke="#231F20"
      strokeWidth="0.258273"
      strokeMiterlimit="10"
    />
    <path
      d="M19.5 32.3743L22.7444 35.5769C22.7444 35.5769 23.5163 34.0144 22.038 32.5422C22.3781 31.8578 22.5482 31.0959 22.5482 30.334"
      fill={fill}
    />
    <path
      d="M19.5 32.3743L22.7444 35.5769C22.7444 35.5769 23.5163 34.0144 22.038 32.5422C22.3781 31.8578 22.5482 31.0959 22.5482 30.334"
      stroke="#231F20"
      strokeWidth="0.258273"
      strokeMiterlimit="10"
    />
    <path
      d="M19.4611 28.3329L22.7056 25.1432C22.7056 25.1432 21.1618 24.3943 19.6966 25.7889C18.9902 25.4403 18.2052 25.2595 17.4072 25.2595"
      fill={fill}
    />
    <path
      d="M19.4611 28.3329L22.7056 25.1432C22.7056 25.1432 21.1618 24.3943 19.6966 25.7889C18.9902 25.4403 18.2052 25.2595 17.4072 25.2595"
      stroke="#231F20"
      strokeWidth="0.258273"
      strokeMiterlimit="10"
    />
    <path
      d="M17.3944 32.026C18.3409 32.026 19.1082 31.2686 19.1082 30.3343C19.1082 29.4 18.3409 28.6426 17.3944 28.6426C16.448 28.6426 15.6807 29.4 15.6807 30.3343C15.6807 31.2686 16.448 32.026 17.3944 32.026Z"
      fill={fill}
      stroke="#231F20"
      strokeWidth="0.258273"
      strokeMiterlimit="10"
    />
    <path
      d="M21.0307 26.7451C21.5932 27.3004 22.0118 27.959 22.2604 28.6951C24.3405 28.708 24.903 30.348 24.903 30.348H20.3242"
      fill={fill}
    />
    <path
      d="M21.0307 26.7451C21.5932 27.3004 22.0118 27.959 22.2604 28.6951C24.3405 28.708 24.903 30.348 24.903 30.348H20.3242"
      stroke="#231F20"
      strokeWidth="0.258273"
      strokeMiterlimit="10"
    />
  </svg>
);
